import { memo } from "react";

interface Props {
  className?: string;
}
function ClockIcon({ className }: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z"
        stroke="#667085"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M12.0039 6V12.005L16.2434 16.245"
        stroke="#667085"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(ClockIcon);
